module.exports = __webpack_public_path__ + "img/img002.42f94eda.png";